var map = {
	"./Arrow.svg": "dda8",
	"./Buscar.svg": "3623",
	"./EnConstru.png": "2c6a",
	"./caja-vacia.svg": "c878",
	"./cart-off.svg": "addc",
	"./cerrar.svg": "a40f",
	"./cerrar_azul.svg": "2b6c",
	"./coche.svg": "7712",
	"./dashboard/ingreso.svg": "3963",
	"./dashboard/ordenes.svg": "9e31",
	"./doble.svg": "2352",
	"./favicon.png": "5be0",
	"./flecha-regresar-verde.svg": "c1c5",
	"./fondo.svg": "3299",
	"./garage.png": "6993",
	"./garageMovil.png": "23d8",
	"./garageTablet.png": "ee71",
	"./icons/Dropdown.svg": "3864",
	"./icons/actualizar.svg": "a7b2",
	"./icons/calendario-verde.svg": "f7cd",
	"./icons/flecha-dark.svg": "35d1",
	"./icons/icon-edit.svg": "f7e1",
	"./icons/icono-addCita.svg": "b256",
	"./icons/icono-cerrarModal.svg": "fed8",
	"./icons/icono-exito.svg": "b168",
	"./icons/icono-falla.svg": "542a",
	"./icons/mono-editar.svg": "203b",
	"./logo.svg": "fef8",
	"./logorm.png": "1226",
	"./logorm.svg": "62a5",
	"./menu/catalogo.svg": "3232",
	"./menu/citas.svg": "9918",
	"./menu/historial.svg": "2419",
	"./menu/inicio.svg": "d513",
	"./menu/inventario.svg": "bf53",
	"./menu/orden.svg": "12f7",
	"./menu/punto-venta.svg": "6e40",
	"./menu/reportes.svg": "5a96",
	"./menu/salir.svg": "d45f",
	"./neumatico.svg": "1d52",
	"./neumaticos.jpg": "a700",
	"./orden.png": "9ded",
	"./puntoVenta/Grupo 15080.svg": "8eff",
	"./puntoVenta/abrir caja icon.svg": "cb79",
	"./puntoVenta/aceptar.svg": "9cc1",
	"./puntoVenta/cajaCerrada.svg": "8566",
	"./puntoVenta/calculadora icon.svg": "919b",
	"./puntoVenta/check blanco.svg": "ab6f",
	"./puntoVenta/efectivo verde.svg": "a8fa",
	"./puntoVenta/eliminar blanco.svg": "474c",
	"./puntoVenta/eliminar red.svg": "7917",
	"./puntoVenta/mas icon.svg": "ddd8",
	"./puntoVenta/no hay productos iocn.svg": "39ac",
	"./puntoVenta/no product icon.svg": "a596",
	"./puntoVenta/reactivar blanco.svg": "39e0",
	"./puntoVenta/reactivar icon.svg": "d419",
	"./puntoVenta/sin info apertura.svg": "b724",
	"./puntoVenta/tarjeta debito verde.svg": "3fd3",
	"./puntoVenta/volver icon.svg": "12c3",
	"./rm.png": "6e11",
	"./rm.svg": "f916",
	"./tallerAutomotriz.svg": "9c4c",
	"./user-not-found.png": "1148"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33db";